module.exports = __webpack_public_path__ + "img/buffalo-chicken-tenders.bec6150e.jpg";